import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { SysIssue } from '~/models/administration/sysIssue';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class SysIssuesService extends ApiServiceBase {
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.adminStock);
    }

    getSysIssue() {
        return this.http.get<SysIssue>(this._url());
    }

    updateSysIssue(model: any) {
        return this.client.put(this._url(), model);
    }

    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/SysIssues${v}`);
    }
}
